(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curiosa-question-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('curiosa-question-reviews')) {
    customElements.define('curiosa-question-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const cards = [...this.querySelectorAll('[data-cqr-card]')];
        const dots = [...this.querySelectorAll('.cqr__dot')];
        const counter = this.querySelector('[data-cqr-count]');
        let index = 0;
        const show = next => {
          if (!cards.length) return;
          index = (next + cards.length) % cards.length;
          cards.forEach((card, i) => { card.hidden = i !== index; });
          dots.forEach((dot, i) => dot.classList.toggle('is-current', i === index));
          if (counter) counter.textContent = `${index + 1} / ${cards.length}`;
        };
        this.querySelector('[data-cqr-prev]')?.addEventListener('click', () => show(index - 1), options);
        this.querySelector('[data-cqr-next]')?.addEventListener('click', () => show(index + 1), options);
        const deck = this.querySelector('.cqr__deck');
        let touch = null;
        deck?.addEventListener('touchstart', event => {
          const point = event.changedTouches[0];
          touch = { x: point.clientX, y: point.clientY };
        }, { ...options, passive:true });
        deck?.addEventListener('touchend', event => {
          if (!touch) return;
          const point = event.changedTouches[0];
          const dx = point.clientX - touch.x, dy = point.clientY - touch.y;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
          touch = null;
        }, { ...options, passive:true });
        deck?.addEventListener('touchcancel', () => { touch = null; }, options);
        this.addEventListener('shopify:block:select', event => {
          const selected = cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (selected >= 0) show(selected);
        }, options);
        const findWidget = () => {
          let sibling = this.closest('.shopify-section')?.nextElementSibling;
          while (sibling) {
            const widget = sibling.querySelector('.jdgm-rev-widg');
            if (widget) return widget;
            sibling = sibling.nextElementSibling;
          }
          return null;
        };
        this.querySelector('[data-cqr-write]')?.addEventListener('click', () => {
          const widget = findWidget();
          const link = widget?.querySelector('.jdgm-write-rev-link');
          if (link) {
            link.click();
            requestAnimationFrame(() => {
              const form = widget.querySelector('.jdgm-form-wrapper');
              (form || widget).scrollIntoView({ behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center' });
            });
          } else if (widget) widget.scrollIntoView({ block:'center' });
        }, options);
        const translateLink = () => {
          const link = findWidget()?.querySelector('.jdgm-row-readmore .jdgm-btn');
          if (link && link.textContent.trim() !== this.dataset.moreLabel) link.textContent = this.dataset.moreLabel;
        };
        if (this.dataset.reviewScope !== 'none') {
          this.observer = new MutationObserver(translateLink);
          this.observer.observe(this.closest('main') || document.body, { childList:true, subtree:true });
          translateLink();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curiosa-search-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('curiosa-home-search')) {
  customElements.define('curiosa-home-search', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.c-home-search__results');
      this.list = this.querySelector('[data-search-products]');
      this.status = this.querySelector('[data-search-status]');
      this.all = this.querySelector('[data-search-all]');
      this.sequence = 0;
      this.cache = new Map();
      this.input.addEventListener('input', () => this.schedule());
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          clearTimeout(this.timer);
          this.controller?.abort();
          this.sequence++;
          this.results.hidden = true;
        }
      });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
    schedule() {
      clearTimeout(this.timer);
      this.controller?.abort();
      const sequence = ++this.sequence;
      const query = this.input.value.trim();
      this.list.replaceChildren();
      if (query.length < 2) {
        this.results.hidden = true;
        return;
      }
      const full = new URL(this.dataset.searchUrl, window.location.origin);
      full.searchParams.set('q', query);
      full.searchParams.set('type', 'product');
      full.searchParams.set('options[prefix]', 'last');
      this.all.href = full.pathname + full.search;
      this.results.hidden = false;
      this.status.textContent = this.dataset.loading;
      this.timer = setTimeout(() => this.search(query, sequence), 250);
    }
    async search(query, sequence) {
      try {
        let products = this.cache.get(query);
        if (!products) {
          this.controller = new AbortController();
          const endpoint = new URL(this.dataset.searchUrl + '/suggest.json', window.location.origin);
          endpoint.searchParams.set('q', query);
          endpoint.searchParams.set('resources[type]', 'product');
          endpoint.searchParams.set('resources[limit]', '5');
          endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
          const response = await fetch(endpoint, { signal: this.controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Search unavailable');
          const body = await response.json();
          products = body.resources?.results?.products;
          if (!Array.isArray(products)) throw new Error('Invalid search response');
          if (this.cache.size >= 10) this.cache.delete(this.cache.keys().next().value);
          this.cache.set(query, products);
        }
        if (sequence !== this.sequence || !this.isConnected) return;
        this.list.replaceChildren();
        let count = 0;
        for (const product of products) {
          const destination = new URL(product.url, window.location.origin);
          if (destination.origin !== window.location.origin || !/^https?:$/.test(destination.protocol)) continue;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.className = 'c-home-search__result';
          link.href = destination.pathname + destination.search;
          const source = product.featured_image?.url || product.image;
          if (typeof source === 'string' && source) {
            const imageUrl = new URL(source, window.location.origin);
            if (/^https?:$/.test(imageUrl.protocol)) {
              imageUrl.searchParams.set('width', '120');
              const image = document.createElement('img');
              image.src = imageUrl.href;
              image.alt = '';
              image.width = 48;
              image.height = 56;
              image.loading = 'lazy';
              link.append(image);
            }
          }
          const name = document.createElement('span');
          name.textContent = product.title;
          link.append(name);
          item.append(link);
          this.list.append(item);
          count++;
        }
        this.status.textContent = count ? this.dataset.found : this.dataset.empty;
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence || !this.isConnected) return;
        this.list.replaceChildren();
        this.status.textContent = this.dataset.error;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
